export const selectionOnCanvas = (
  selectedIds: string[],
  canvasIds: readonly string[],
): string[] => {
  const onCanvas = selectedIds.filter((id) => canvasIds.includes(id))
  return onCanvas.length === selectedIds.length ? selectedIds : onCanvas
}
